import {
  COMPANY_SWITCHER_WIDTH,
  DRAWER_WIDTH,
  NEW_SIDEBAR_DRAWER_WIDTH,
} from 'src/constants/uiConsts';
import { useFeatureFlags } from 'src/context';
import { useCompanySwitcherVisibility } from 'src/features/companies/useCompanySwitcherVisibility';
import { useWindowSize } from 'src/hooks/useWindowResize';

// null = legacy drawer mode (returns DRAWER_WIDTH constant)
// number = panel mode: 0 when collapsed, >0 when expanded
export const useDrawerWidth = (
  panelSizePercent: number | null = null,
): number => {
  const { EnableNewSidebar } = useFeatureFlags();
  const drawerWidth = EnableNewSidebar
    ? NEW_SIDEBAR_DRAWER_WIDTH
    : DRAWER_WIDTH;
  const isSidebarCompanySwitcherVisible = useCompanySwitcherVisibility();
  const { width } = useWindowSize();

  if (panelSizePercent !== null) {
    return panelSizePercent > 0
      ? Math.round((panelSizePercent / 100) * width)
      : 0;
  }

  return isSidebarCompanySwitcherVisible.visibility === 'desktop'
    ? drawerWidth + COMPANY_SWITCHER_WIDTH
    : drawerWidth;
};
